export default __webpack_public_path__ + "static/media/Thyroid.32df2da9.svg";